import type { ProjectDetail } from "./project.type";
import type { UseGetOptions } from "@/hooks/queries";

import { useGet } from "@/hooks/queries";

export const useGetProject = (
  projectId?: number | string,
  options?: UseGetOptions<ProjectDetail>
) => {
  const { data, ...queryResult } = useGet<ProjectDetail>(
    "projects",
    projectId,
    options
  );

  return {
    project: data,
    ...queryResult,
  };
};
